<!-- start marketplace -->
<section class="section bg-light" id="services">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h2 class="mb-3 fw-bold lh-base">Explore Birds</h2>
                    <p class="text-muted mb-4">Collection of birds captured groups by area.</p>
                    <ul class="nav nav-pills filter-btns justify-content-center" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-medium active" type="button" data-filter="all"
                                (click)="activeCategory('allItems')"
                                [ngClass]="{'active': galleryFilter ==='allItems'}">Whole Sibu</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-medium" type="button" data-filter="artwork"
                                (click)="activeCategory('artWork')"
                                [ngClass]="{'active': galleryFilter ==='artWork'}">Apollo</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-medium" type="button" data-filter="music"
                                (click)="activeCategory('music')"
                                [ngClass]="{'active': galleryFilter ==='music'}">Penasu</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link fw-medium" type="button" data-filter="games"
                                (click)="activeCategory('games')"
                                [ngClass]="{'active': galleryFilter ==='games'}">Ulu Sungai Merah</button>
                        </li>
                    </ul>
                </div>
            </div><!-- end col -->
        </div><!-- end row -->
        <div class="row">
            <div class="col-lg-4 product-item artwork crypto-card 3d-style" *ngFor="let data of filterredImages">
                <div class="card explore-box card-animate">
                    <div class="bookmark-icon position-absolute top-0 end-0 p-2">
                        <button type="button" class="btn btn-icon active" data-bs-toggle="button" aria-pressed="true"><i
                                class="mdi mdi-cards-heart fs-16"></i></button>
                    </div>
                    <div class="explore-place-bid-img">
                        <img src="{{data.image}}" alt="" class="card-img-top explore-img" />
                        <div class="bg-overlay"></div>
                    </div>
                    <div class="card-body">
                        <h5 class="mb-1"><a href="/nft-details">{{data.title}}</a></h5>
                        <p class="text-muted mb-0">{{data.sub_title}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- end container -->
</section>
<!-- end marketplace -->
